var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/scenariolibrary/".concat(_vm.item.id)
    }
  }, [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "width": _vm.$size() * 4,
      "height": _vm.$size(),
      "tile": ""
    }
  }, [_c('v-img', {
    staticClass: "quest-library-icon",
    attrs: {
      "src": _vm.item.icon,
      "contain": ""
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "ml-0",
    style: {
      'max-width': '240px'
    }
  }, [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.item.name))])], 1), _c('div', {
    staticClass: "mr-auto"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }